<template>
	<div class="pedigreeInfo">
		<van-row style="margin-bottom:5px;">
			<van-col span="18">
				<van-field
					v-model.trim="pdgInfo.family_name"
					label="族姓："
					placeholder="请输入族姓"
					required
					clearable
					@change="resetName"
				>
					<template #right-icon>
						<van-icon name="ellipsis" @click="showFamilyPicker=true"/>
					</template>
				</van-field>
				<van-field
					v-model.trim="pdgInfo.name"
					label="族谱名称："
					placeholder="请输入族谱名称"
					required
					clearable
				></van-field>
				<van-field
					v-model.trim="pdgInfo.hall_name"
					label="堂号："
					placeholder="请输入堂号"
					clearable
				></van-field>
			</van-col>
			<van-col span="6" style="background-color:#fff;">
				<van-uploader ref="clansLogoUploader" :style="'height:90px;'" max-count="1" v-model="imgList" :max-size="imgSizeLimit" @oversize="onOversize" :after-read="afterReadImg" :before-read="beforeRead"/>
			</van-col>
		</van-row>
		<van-cell-group class="self"> 
			<van-cell
				@click="showPicker=!showPicker"
				title="地区："
				required
				is-link
				:value="pdgInfo.area"
				title-class="van-cell-title"
			></van-cell>
			<van-field
				v-model.trim="pdgInfo.address"
				label="地址："
				required
				placeholder="请输入地址"
				clearable
			@blur="locationAmapByAddress(pdgInfo.address)"
			></van-field>
			<div id="amap_container_pdg" class="amap_container"></div>

			<van-cell
				@click="showMarkPicker=!showMarkPicker"
				title="祭祖日期："
				is-link
				:value="pdgInfo.mark_date"
				title-class="van-cell-title"
			></van-cell>
			<van-field
				v-if="edit"
			  v-model.trim="pdgInfo.family_rule"
			  rows="3"
			  autosize
			  label="家规祖训："
			  type="textarea"
			  maxlength="3000"
			  placeholder="请输入家规祖训..."
			  show-word-limit
			/>
			<van-field
				v-if="edit"
			  v-model.trim="pdgInfo.preface"
			  rows="3"
			  autosize
			  label="前言："
			  type="textarea"
			  maxlength="3000"
			  placeholder="请输入前言..."
			  show-word-limit
			/>
			<van-field
				v-if="edit"
			  v-model.trim="pdgInfo.source"
			  rows="3"
			  autosize
			  label="宗源："
			  type="textarea"
			  maxlength="3000"
			  placeholder="请输入宗源..."
			  show-word-limit
			/>
			<van-field
				v-if="edit"
			  v-model.trim="pdgInfo.seniority"
			  rows="3"
			  autosize
			  label="辈分："
			  type="textarea"
			  maxlength="3000"
			  placeholder="请输入辈分内容..."
			  show-word-limit
			/>
			<van-field
				v-if="edit"
			  v-model.trim="pdgInfo.remark"
			  rows="3"
			  autosize
			  label="简介："
			  type="textarea"
			  maxlength="3000"
			  placeholder="请输入简介内容..."
			  show-word-limit
			/>

			<van-button type="primary" block  @click="savePedigree()">保存</van-button>
		</van-cell-group>



		<van-popup v-model="showPicker" position="bottom">
		  <van-picker
			show-toolbar
			title="请选择"
			:columns="areaColumns"
			@cancel="showPicker = false"
			@confirm="onAreaConfirm"
		  />
		</van-popup>

		<van-popup v-model="showMarkPicker" position="bottom">
		  <van-picker
			show-toolbar
			title="请选择"
			:columns="markColumns"
			@cancel="showMarkPicker = false"
			@confirm="onMarkConfirm"
		  />
		</van-popup>

		<van-popup v-model="showFamilyPicker" position="right" :style="{ 'width': '200px','height':'80%' }" get-container=".pedigreeInfo">
			<van-index-bar v-if="families.length" :index-list="firstPin">
				<span v-for="(fm, ind) in families" :key="ind">
					<van-index-anchor :index="fm.char"/>
					<van-cell :title="n" v-for="(n, ind2) in fm.data" :key="ind+'_'+ind2" @click="selFamilyName(n)"/>
				</span>
			</van-index-bar>
		</van-popup>


	</div>
</template>

<script>

import { Col, Row, IndexBar, IndexAnchor } from 'vant';
import { FirstPin,chkImgType } from "@/utils/common.js";
export default {
	name: "pedigreeInfo",
	components: {
		"van-row":Row,
		"van-col":Col,
		"van-index-bar":IndexBar,
		"van-index-anchor":IndexAnchor
	},
	props:{
		pdgInfo:Object,
		imgList:Array,
		edit:Boolean,
		families:Array
	},
	data() {
		return {
			firstPin:FirstPin,
			u_id: localStorage.getItem("u_id"),
			token: localStorage.getItem(localStorage.getItem("u_id")+"token"),
			areaColumns:JSON.parse(localStorage.getItem("area_districts")),
			amap:{},
			amapGeocoder:{},
			amapMarker:false,
			showPicker:false,

			showMarkPicker:false,

			showFamilyPicker:false,
			//imgList:[],
			imgSizeLimit:500 * 1024,
			preAddress:''
		};
	},
	computed:{
		markColumns:function(){
			let lMonths = ['正月','二月','三月','四月','五月','六月','七月','八月','九月','十月','十一月','十二月'];
			let lMonthDays = [{text:'初一'},{text:'初二'},{text:'初三'},{text:'初四'},{text:'初五'},{text:'初六'},{text:'初七'},{text:'初八'},{text:'初九'},{text:'初十'},{text:'十一'},{text:'十二'},{text:'十三'},{text:'十四'},{text:'十五'},{text:'十六'},{text:'十七'},{text:'十八'},{text:'十九'},{text:'廿一'},{text:'廿二'},{text:'廿三'},{text:'廿四'},{text:'廿五'},{text:'廿六'},{text:'廿七'},{text:'廿八'},{text:'廿九'},{text:'三十'}];
			let vals = [];
			let lOpts = [];
			for(var i=0,il=12;i<il;i++){
				lOpts.push({text:lMonths[i],children:lMonthDays});
			}
			vals.push({text: '阴历',children:lOpts});
			let sMonths = ['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月'];
			//let sMonthDays = ['1日','2日','3日','4日','5日','6日','7日','8日','9日','10日','11日','12日','13日','14日','15日','16日','17日','18日','19日','20日','21日','22日','23日','24日','25日','26日','27日','28日','29日','30日','31日'];
			let sOpts = [];
			let sMonthDays = [];
			let mdays = 0;
			for(var i=0,il=12;i<il;i++){
				mdays = 30;
				if(i==1){
					mdays = 29;
				}else if(i%2 == 0){
					mdays = 31;
				}
				sMonthDays = [];
				for(var m=0;m<mdays;m++){
					sMonthDays.push({text:(m+1)+'日'});
				}
				sOpts.push({text:sMonths[i],children:sMonthDays});
			}
			vals.push({text: '阳历',children:sOpts});
			return vals;
		}
	},
	methods: {
		onAreaConfirm(value, indexs) {
			this.showPicker = false;
			this.pdgInfo['area'] = value.join("")
			this.initAmapByCity(value.join(""))
		},
		onMarkConfirm(value, indexs){
			this.showMarkPicker = false;
			this.pdgInfo['mark_date'] = value.join("")
			this.markColumns[0].defaultIndex = indexs[0];
			this.markColumns[1].defaultIndex = indexs[1];
			this.markColumns[2].defaultIndex = indexs[2];
		},
		initAmapByCity(cityad){
			this.locationAmapByAddress(cityad)
		},
		markerAmap(lnglat, reset){
			if(this.amapMarker){
				this.amap.remove(this.amapMarker);
			}
			this.amapMarker = new AMap.Marker();
			this.amapMarker.setPosition(lnglat);
			this.amap.add(this.amapMarker);
			this.amap.setFitView(this.amapMarker);
			this.pdgInfo['lnglat'] = lnglat[0] + ',' + lnglat[1];
			if(reset){
				this.resetAddressByLnglat(lnglat);
			}
		},
		resetAddressByLnglat(lnglat){
			var geocoder = new AMap.Geocoder({
				city: ''
			})
			let that = this;
			geocoder.getAddress(lnglat, function (status, data) {
				if (status === 'complete' && data.info === 'OK') {
					// result为对应的地理位置详细信息
					//console.log(data)
					let faddress = data.regeocode.formattedAddress;
					let acomp = data.regeocode.addressComponent;
					let district = acomp.district;
					if(!(that.pdgInfo.area && that.pdgInfo.area.indexOf(district) > -1)){
						that.pdgInfo.area = acomp.province+acomp.city+district;
					}
					let fadr = faddress.split(district);
					that.$delete(fadr, 0);
					that.pdgInfo.address = fadr.join(district);
					that.$forceUpdate();
				}
			})

		},
		locationAmapByAddress(ads){
			if(ads && ads != this.preAddress){
				let that = this;
				this.amapGeocoder.getLocation(ads, function(status, result) {
					if (status === 'complete'&&result.geocodes.length) {
						let local = result.geocodes[0].location;
						that.markerAmap([local.lng, local.lat],0);
					}else{
						that.$toast.fail("地址定位失败，请手动指定");
					}
				});
			}
		},
		selFamilyName(n){
			this.pdgInfo.family_name = n;
			this.showFamilyPicker = false;
			if(!this.pdgInfo.name){
				this.forceUpdateName(n);
			}
		},
		resetName(){
			this.showClansName();
		},
		showClansName(){
			let elm = this.$refs['clansLogoUploader'].$children[0].$el;
			if(elm.childNodes.length < 2 || (elm.childNodes.length >= 2 && elm.childNodes[1].tagName!='SPAN')){
				let spelm = document.createElement('span');
				spelm.setAttribute('class','clans-title');
				if(this.pdgInfo.name.length > 4){
					spelm.style.fontSize = (14-(this.pdgInfo.name.length-4)*2)+'px';
				}
				spelm.appendChild(document.createTextNode(this.pdgInfo.name));
				elm.append(spelm);
			}else{
				elm.childNodes[1].innerHTML = "";
				elm.childNodes[1].appendChild(document.createTextNode(this.pdgInfo.name));
			}
		},
		beforeRead(file){
			return chkImgType(file);
		},
		onOversize(){
			this.$toast.fail("图片大小不能超过 500kb");
		},
		afterReadImg(file){
			this.params['s_license'] = file.content
			this.licenseList = [{url:file.content, isImage: true}];
		},
		savePedigree(){
			if(!this.pdgInfo['family_name']){
				this.$toast.fail("请输入族姓！");
				return false;
			}
			if(!this.pdgInfo['name']){
				this.$toast.fail("请输入族谱名称！");
				return false;
			}
			/**
			if(!this.pdgInfo['hall_name']){
				this.$toast.fail("请输入堂号！");
				return false;
			}
			*/
			if(!this.pdgInfo['area']){
				this.$toast.fail("请选择地区！");
				return false;
			}
			if(!this.pdgInfo['address']){
				this.$toast.fail("请填写地址！");
				return false;
			}
			if(!this.pdgInfo['lnglat']){
				this.$toast.fail("请在地图上标记位置！");
				return false;
			}
			if(this.u_id && this.token){
				this.pdgInfo['u_id'] = this.u_id;
				if(this.imgList.length > 0 && this.imgList[0].content){
					this.pdgInfo['clan_img'] = this.imgList[0].content;
				}
				var params = {
					u_id:this.u_id,
					token:this.token,
					data:this.pdgInfo
				};
				let that = this;
				var url = this.Conf.serverUrl + "clans/savePedigree" + "?num="+Math.random();
				this.$axios
				.post(url, this.$qs.stringify(params))
				.then(response => {
					that.$toast.success(response.data.msg);
					if(response.data.code == 200){
						that.$emit("callAfterSave",  {
							family_name:this.pdgInfo.family_name,
							name:this.pdgInfo.name,
							area:this.pdgInfo.area
						});
					}
				})
				.catch(error => {});
			}else{
				this.$toast.fail("请先登录！");
				this.$emit("callAfterSave",null);
			}
		},
		forceUpdateName(n){
			this.pdgInfo.name = n+'氏族谱';
			this.$forceUpdate();
			this.showClansName();
		}
	},
	created() {
		let that = this;
		this.$nextTick(() => {
			that.amap = new AMap.Map("amap_container_pdg", {
				resizeEnable: true
			});
			if(!that.readonly){
				that.amap.on('click', function(e) {
					that.markerAmap([e.lnglat.getLng(), e.lnglat.getLat()],1);
				});
			}
			that.amapGeocoder = new AMap.Geocoder({
				city:''//cityad
			});
			if(that.pdgInfo && that.pdgInfo.lnglat){
				that.markerAmap(that.pdgInfo.lnglat.split(","),0);
			}
			if(that.pdgInfo.name){
				that.showClansName();
			}else if(that.pdgInfo.family_name){
				that.forceUpdateName(that.pdgInfo.family_name);
			}
			that.preAddress = that.pdgInfo.address;
		});

	},
	watch:{
		'pdgInfo.name'(nval, oval){
			this.showClansName()
		},
		'pdgInfo.family_name'(nval, oval){
			if(!this.pdgInfo.name && nval){
				this.forceUpdateName(nval);
			}
		}
	}
};
</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Clans/PedigreeInfo.vue